// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caller-modal-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 0.5rem;
  background-color: var(--surface-primary);
  text-align: center;
  display: flex;
  flex-direction: column;
}

.modal-header {
  height: 3.5rem;
  display: flex;
  align-items: center;
  padding-left: 1rem;
  flex-shrink: 0;
}
.modal-header ion-icon {
  color: var(--ion-color-primary);
  font-size: 1.5rem;
}

.caller-w {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.caller-name {
  color: var(--text-primary);
  font-weight: bold;
  font-size: 1.625rem;
  line-height: 2rem;
  margin: 0;
}

.participant-type-text {
  font-weight: normal;
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.4px;
  color: var(--text-secondary);
  margin: 0.25rem 0 0;
}

.button-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2rem;
  width: 9rem;
}
@media (max-width: 576px) {
  .button-container {
    width: 12.5rem;
  }
}

.button-container--calling {
  width: auto;
}

.accept-call-icon {
  color: #ffffff;
  font-size: 1.1875rem;
}

#dismiss {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/caller-modal/caller-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACJ;AACI;EACI,+BAAA;EACA,iBAAA;AACR;;AAGA;EACI,WAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,0BAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;AAAJ;AAEI;EAPJ;IAQQ,cAAA;EACN;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACI,cAAA;EACA,oBAAA;AACJ;;AAEA;EACI,aAAA;AACJ","sourcesContent":[".caller-modal-wrapper {\n    width: 100%;\n    height: 100%;\n    border-radius: 0.5rem;\n    background-color: var(--surface-primary);\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n}\n\n.modal-header {\n    height: 3.5rem;\n    display: flex;\n    align-items: center;\n    padding-left: 1rem;\n    flex-shrink: 0;\n\n    ion-icon {\n        color: var(--ion-color-primary);\n        font-size: 1.5rem;\n    }\n}\n\n.caller-w {\n    width: 100%;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.caller-name {\n    color: var(--text-primary);\n    font-weight: bold;\n    font-size: 1.625rem;\n    line-height: 2rem;\n    margin: 0;\n}\n\n.participant-type-text {\n    font-weight: normal;\n    font-size: 0.75rem;\n    line-height: 1rem;\n    letter-spacing: 0.4px;\n    color: var(--text-secondary);\n    margin: 0.25rem 0 0;\n}\n\n.button-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 2rem;\n    width: 9rem;\n\n    @media(max-width: 576px) {\n        width: 12.5rem;\n    }\n}\n\n.button-container--calling {\n  width: auto;\n}\n\n.accept-call-icon {\n    color: #ffffff;\n    font-size: 1.1875rem;\n}\n\n#dismiss {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
